<template>
    <div
        :class="{signPage:!this.$store.state.isMobile,msignPage:this.$store.state.isMobile,mobileCommon:this.$store.state.isMobile}">
        <div class="box">
            <div class="explain" v-if="type=='buyer'">
                <h3>{{ langPage['v4-signpage']['TXT_deveniracheteur'].toUpperCase() }}</h3>
                <div class="tip">
                    <div class="title">{{ langPage['v4-signpage']['TXT_80000paran'] }}</div>
                    <div class="cont">{{ langPage['v4-signpage']['TXT_jusqua80000decommandehtparan'] }}</div>
                </div>
                <div class="tip">
                    <div class="title">{{ langPage['v4-signpage']['TXT_de200nouveaux'] }}</div>
                    <div class="cont" v-html="langPage['v4-signpage']['TAREA_plusde200']">
                    </div>
                </div>
                <div class="tip">
                    <div class="title">{{ langPage['v4-signpage']['TXT_visible24'] }}</div>
                    <div class="cont" v-html="langPage['v4-signpage']['TAREA_vendezmemequandvousdormez']">
                    </div>
                </div>
            </div>
            <div class="explain" v-if="type=='seller'">
                <h3>{{ langPage['v4-signpage']['TXT_devenirvendeur'].toUpperCase() }}</h3>
                <div class="tip">
                    <div class="title">{{ langPage['v4-signpage']['TXT_80000paranvendeur'] }}</div>
                    <div class="cont">{{ langPage['v4-signpage']['TXT_jusqua80000decommandehtparanvendeur'] }}</div>
                </div>
                <div class="tip">
                    <div class="title">{{ langPage['v4-signpage']['TXT_de200nouveauxvendeur'] }}</div>
                    <div class="cont" v-html="langPage['v4-signpage']['TAREA_plusde200vendeur']">
                    </div>
                </div>
                <div class="tip">
                    <div class="title">{{ langPage['v4-signpage']['TXT_visible24vendeur'] }}</div>
                    <div class="cont" v-html="langPage['v4-signpage']['TAREA_vendezmemequandvendeur']">
                    </div>
                </div>
            </div>
            <div class="form">
                <h3>{{ step }}/{{ steptotal }} {{ langPage['v4-compte-inscription']['TXT_vosinformations'] }}</h3>
                <el-form
                    v-if="type == 'buyer'&&step == 1"
                    label-position="top"
                    ref="buyerForm1"
                    :model="buyerForm"
                    :rules="formRulesBuyer1"
                >
                    <el-form-item :label="langPage['v4-topmenu']['TXT_nomducontact']">
                        <el-input class="input" v-model="buyerForm.prenomContact"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_prenomducontact']">
                        <el-input class="input" v-model="buyerForm.nomContact"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['compte-informations']['TXT_email']" prop="email">
                        <el-input class="input" v-model="buyerForm.email"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_confirmationdemail']" prop="email2">
                        <el-input class="input" v-model="buyerForm.email2"></el-input>
                    </el-form-item>
                    <!--                    <el-form-item label="Téléphone mobile*">-->
                    <!--                        <el-input class="input" v-model="buyerForm.mobile"></el-input>-->
                    <!--                    </el-form-item>-->
                    <!--                    <el-form-item label="Téléphone">-->
                    <!--                        <el-input class="input" v-model="buyerForm.phone"></el-input>-->
                    <!--                    </el-form-item>-->
                    <el-form-item :label="langPage['v4-topmenu']['TXT_motdepasse']">
                        <el-input class="input" v-model="buyerForm.password" show-password></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_confirmationdumot']">
                        <el-input class="input" v-model="buyerForm.password2" show-password></el-input>
                    </el-form-item>
                    <!--                                        <img-->
                    <!--                                            :src="i==active1?require('@/assets/img/Radio-on.svg'):require('@/assets/img/Radio-off.svg')"-->
                    <!--                                            alt-->
                    <!--                                        />-->
                    <el-form-item v-bind:label="this.$t('account.word4')">
                        <el-radio-group v-model="buyerForm.newsletter">
                            <el-radio label="1">
                                <div class="radioBox">
                                    <img
                                        :src="buyerForm.newsletter==1?require('@/assets/img/Radio-on.svg'):require('@/assets/img/Radio-off.svg')"
                                        alt
                                    />
                                    <span>{{ this.$t('common.yes') }}</span>
                                </div>
                            </el-radio>
                            <el-radio label="0">
                                <div class="radioBox">
                                    <img
                                        :src="buyerForm.newsletter!=1?require('@/assets/img/Radio-on.svg'):require('@/assets/img/Radio-off.svg')"
                                        alt
                                    />
                                    <span>{{ this.$t('common.no') }}</span>
                                </div>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-bind:label="this.$t('account.word5')">
                        <el-radio-group v-model="buyerForm.platform_notify_status">
                            <el-radio label="1">
                                <div class="radioBox">
                                    <img
                                        :src="buyerForm.platform_notify_status==1?require('@/assets/img/Radio-on.svg'):require('@/assets/img/Radio-off.svg')"
                                        alt
                                    />
                                    <span>{{ this.$t('common.yes') }}</span>
                                </div>
                            </el-radio>
                            <el-radio label="0">
                                <div class="radioBox">
                                    <img
                                        :src="buyerForm.platform_notify_status!=1?require('@/assets/img/Radio-on.svg'):require('@/assets/img/Radio-off.svg')"
                                        alt
                                    />
                                    <span>{{ this.$t('common.no') }}</span>
                                </div>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-bind:label="this.$t('account.word6')">
                        <el-radio-group v-model="buyerForm.sms_notify_status">
                            <el-radio label="1">
                                <div class="radioBox">
                                    <img
                                        :src="buyerForm.sms_notify_status==1?require('@/assets/img/Radio-on.svg'):require('@/assets/img/Radio-off.svg')"
                                        alt
                                    />
                                    <span>{{ this.$t('common.yes') }}</span>
                                </div>
                            </el-radio>
                            <el-radio label="0">
                                <div class="radioBox">
                                    <img
                                        :src="buyerForm.sms_notify_status!=1?require('@/assets/img/Radio-on.svg'):require('@/assets/img/Radio-off.svg')"
                                        alt
                                    />
                                    <span>{{ this.$t('common.no') }}</span>
                                </div>
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>

                </el-form>
                <el-form
                    v-if="type == 'buyer'&&step == 2"
                    label-position="top"
                    ref="buyerForm2"
                    :model="buyerForm"
                    :rules="formRulesBuyer1"
                >
                    <div class="typename">{{ langPage['v4-inscription-grossistes']['TXT_infolegales'].toUpperCase() }}
                    </div>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_raisonsocial']">
                        <el-input class="input" v-model="buyerForm.nomSociete"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_choisissunpay']">
                        <el-select v-model="buyerForm.adresses[0].id_pays" @change="onChangeBuyerCountry" placeholder>
                            <el-option
                                v-for="(item,countryIndex) in countryList"
                                :label="item.text"
                                :value="item.id_pays"
                                :key="countryIndex"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="eori*"
                                  v-if="is_show_eori"
                                  prop="eori">
                        <el-input class="input" v-model="buyerForm.eori"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_siret']" prop="tva_intra">
                        <el-input class="input" v-model="buyerForm.tva_intra"
                                  :disabled="checkedHasNoBuyerSiret"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="checkedHasNoBuyerSiret" @change="onCheckHasNoBuyerSiret">
                            <p v-html="langPage['v4-signpage']['TAREA_monentreprise']"></p>
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_kbis']">
                        <input
                            id="file_kbis_buyer"
                            name="file_kbis_buyer"
                            type="file"
                            value
                            accept="*"
                            ref="kbis_upload_buyer"
                            hidden
                            @change="carteFile($event,100)"
                        />
                        <label for="file_kbis_buyer" class="file-btn">{{
                                langPage['v4-inscription-grossistes']['TXT_choisirunfichir']
                            }}</label>
                        <div class="tip-warp">
                            <template v-if="kbis_img_buyer.name">
                                <div class="tip">
                                    {{ kbis_img_buyer.name }}
                                    <i class="el-icon-close carte-size" @click="delCarteImg(index,100)"></i>
                                </div>
                            </template>
                            <template v-else>
                                <div class="tip">{{ langPage['v4-signpage']['TXT_aucunfichierchoisi'] }}</div>
                            </template>
                        </div>
                    </el-form-item>
                    <!--                    <el-form-item label="Site web">-->
                    <!--                        <el-input class="input" placeholder="http://" v-model="buyerForm.site_web"></el-input>-->
                    <!--                    </el-form-item>-->
                    <el-form-item :label="langPage['v4-topmenu']['TXT_languepardefaut']">
                        <el-select v-model="buyerForm.LangueDefaut" placeholder>
                            <el-option
                                v-for="item in langDate"
                                :label="item.label"
                                :value="item.value"
                                :key="item.label"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_domainedactivite']">
                        <el-checkbox-group v-model="buyerForm.activites">
                            <el-checkbox
                                v-for="(item,index) in businessScope"
                                :key="index"
                                :value="item.id_activite"
                                :label="item.id_activite"
                            >{{ item.libelle }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-divider></el-divider>
                    <div class="typename">{{
                            langPage['compte-popup-adresse']['TXT_adresselivraison'].toUpperCase()
                        }}
                    </div>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_numeroderue']">
                        <el-input class="input" v-model="adresse_ro" @input="rueJoin"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_rue']">
                        <el-input class="input" v-model="adresse_rue" @input="rueJoin"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_codepostal']">
                        <el-input class="input" v-model="buyerForm.adresses[0].codePostal"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_ville']">
                        <el-input class="input" v-model="buyerForm.adresses[0].ville"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_telephonemobile']">
                        <vue-tel-input class="input" v-model="buyerForm.adresses[0].mobile"
                                       v-on:country-changed="onChangePhoneCountry($event,'buyerForm.adresses[0].mobile')"></vue-tel-input>
                    </el-form-item>
                    <el-form-item :label="langPage['compte-informations']['TXT_telephone']">
                        <vue-tel-input class="input" v-model="buyerForm.adresses[0].telephone"
                                       v-on:country-changed="onChangePhoneCountry($event,'buyerForm.adresses[0].telephone')"></vue-tel-input>
                    </el-form-item>
                    <el-form-item :label="langPage['landingpage']['TXT_formnom']">
                        <el-input class="input" v-model="buyerForm.adresses[0].NomContact"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="billAddress">{{ langPage['compte-inscription']['TXT_correspondadrliv'] }}
                        </el-checkbox>
                    </el-form-item>
                    <transition name="fade">
                        <div class="billAddress" v-if="!billAddress">
                            <div class="typename">
                                {{ langPage['compte-popup-adresse']['TXT_adressefacturation'].toUpperCase() }}
                            </div>
                            <el-form-item :label="langPage['v4-topmenu']['TXT_numeroderue']">
                                <el-input class="input" v-model="seAdresse_ro" @input="seRueJoin"></el-input>
                            </el-form-item>
                            <el-form-item :label="langPage['v4-topmenu']['TXT_rue']">
                                <el-input class="input" v-model="seAdresse_rue" @input="seRueJoin"></el-input>
                            </el-form-item>
                            <el-form-item :label="langPage['v4-topmenu']['TXT_codepostal']">
                                <el-input class="input" v-model="buyerForm.adresses[1].codePostal"></el-input>
                            </el-form-item>
                            <el-form-item :label="langPage['v4-topmenu']['TXT_ville']">
                                <el-input class="input" v-model="buyerForm.adresses[1].ville"></el-input>
                            </el-form-item>
                            <el-form-item :label="langPage['v4-topmenu']['TXT_telephonemobile']">
                                <vue-tel-input class="input" v-model="buyerForm.adresses[1].mobile"
                                               v-on:country-changed="onChangePhoneCountry($event,'buyerForm.adresses[1].mobile')"></vue-tel-input>
                            </el-form-item>
                            <el-form-item :label="langPage['compte-informations']['TXT_telephone']">
                                <vue-tel-input class="input" v-model="buyerForm.adresses[1].telephone"
                                               v-on:country-changed="onChangePhoneCountry($event,'buyerForm.adresses[1].telephone')"></vue-tel-input>
                            </el-form-item>
                            <el-form-item :label="langPage['landingpage']['TXT_formnom']">
                                <el-input class="input" v-model="buyerForm.adresses[1].NomContact"></el-input>
                            </el-form-item>
                        </div>
                    </transition>
                    <el-form-item>
                        <el-checkbox
                            v-model="agreeMent"
                            @change="agreeMentCvg"
                            style="white-space: pre-wrap;display: flex"
                        >{{ langPage['compte-inscription']['TXT_acceptecguv'] }}
                            <el-link href="/conditions/commonPage?type=cguv" type="danger">VOIR CONDITIONS</el-link>
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox
                            v-model="agreeMentSecret">
                            <div v-html="langPage['v4-signpage']['TAREA_jacceptequeefashion']">
                                <el-link href="/conditions/commonPage?type=pdc" type="danger">
                                    {{ langPage['compte-inscription']['TXT_voircondition'].toUpperCase() }}
                                </el-link>
                            </div>
                        </el-checkbox>
                    </el-form-item>
                </el-form>

                <!-- 卖家注册 -->
                <el-form
                    v-if="type == 'seller'&&step == 1"
                    label-position="top"
                    ref="buyerForm3"
                    :model="sellerForm1"
                    :rules="formRulesSeller"
                >
                    <el-form-item :label="langPage['v4-topmenu']['TXT_raisonsocial']">
                        <el-input class="input" v-model="sellerForm1.nomSociete"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_nom']">
                        <el-input class="input" v-model="sellerForm1.nomContact"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_prenom']">
                        <el-input class="input" v-model="sellerForm1.prenomContact"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_telephonemobile']">
                        <el-input class="input" v-model="sellerForm1.mobile"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_numerodetele']">
                        <el-input class="input" v-model="sellerForm1.telephone"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_email']" prop="email">
                        <el-input class="input" v-model="sellerForm1.email"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_confirmationdemail']" prop="email2">
                        <el-input class="input" v-model="sellerForm1.email2"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_motdepasse']">
                        <el-input class="input" v-model="sellerForm1.password" show-password></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_confirmationdumot']">
                        <el-input class="input" v-model="sellerForm1.password2" show-password></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_numerodetva']">
                        <el-input class="input" v-model="sellerForm1.tva"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_nomdumagasin']">
                        <el-input class="input" v-model="sellerForm1.nomBoutique"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_choisissunpay']">
                        <el-select v-model="sellerForm1.id_pays" placeholder>
                            <el-option
                                v-for="(item,countryIndex) in countryList"
                                :label="item.text"
                                :value="item.id_pays"
                                :key="countryIndex"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-form
                    v-if="type == 'seller'&&step == 2"
                    label-position="top"
                    ref="buyerForm4"
                    :model="sellerForm2"
                >
                    <div class="typename">{{ langPage['mobile-produits']['TXT_adresse'] }}</div>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_numeroderue']">
                        <el-input class="input" v-model="sellerForm2.numero"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_rue']">
                        <el-input class="input" v-model="sellerForm2.rue"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_codepostal']">
                        <el-input class="input" v-model="sellerForm2.codePostal"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_ville']">
                        <el-input class="input" v-model="sellerForm2.ville"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_complementdadresse']">
                        <el-input class="input" v-model="sellerForm2.adresse"></el-input>
                    </el-form-item>
                    <div class="typename">{{
                            langPage['v4-inscription-grossistes']['TXT_infolegales'].toUpperCase()
                        }}
                    </div>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_kbis']">
                        <!-- <el-upload
                          class="upload-demo"
                          action="https://jsonplaceholder.typicode.com/posts/"
                          multiple
                          :limit="3"
                          :file-list="fileList"
                          style="display: inline-block;margin-right: 12px;"
                        >
                          <el-button size="middle">Choisir un fichier</el-button>
                        </el-upload>
                        <div class="tip">Aucun fichier choisi</div>-->
                        <input
                            id="file_kbis"
                            name="file_kbis"
                            type="file"
                            value
                            accept="*"
                            ref="kbis_upload"
                            hidden
                            @change="carteFile($event,1)"
                        />
                        <label for="file_kbis" class="file-btn">{{
                                langPage['v4-inscription-grossistes']['TXT_choisirunfichir']
                            }}</label>
                        <div class="tip-warp">
                            <template v-if="kbis_img.name">
                                <div class="tip">
                                    {{ kbis_img.name }}
                                    <i class="el-icon-close carte-size" @click="delCarteImg(index,1)"></i>
                                </div>
                            </template>
                            <template v-else>
                                <div class="tip">{{ langPage['v4-signpage']['TXT_aucunfichierchoisi'] }}</div>
                            </template>
                        </div>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_numeroiban']">
                        <el-input class="input" v-model="sellerForm2.iban"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_bic']">
                        <el-input class="input" v-model="sellerForm2.bic"></el-input>
                    </el-form-item>

                    <el-form-item :label="langPage['v4-topmenu']['TXT_piecedidentide']">
                        <!-- <el-upload
                                class="upload-demo"
                                action="https://jsonplaceholder.typicode.com/posts/"
                                multiple
                                :limit="3"
                                :file-list="fileList"
                                style="display: inline-block;margin-right: 12px;">
                            <el-button size="middle">Choisir un fichier</el-button>
                        </el-upload>-->
                        <input
                            id="file_carte"
                            name="file_carte"
                            type="file"
                            accept="image/*"
                            value
                            ref="carte_upload"
                            hidden
                            @change="carteFile($event,2)"
                        />
                        <label for="file_carte" class="file-btn">{{
                                langPage['v4-inscription-grossistes']['TXT_choisirunfichir']
                            }}</label>
                        <div class="tip-warp">
                            <template v-if="carte_img.name">
                                <div class="tip">
                                    {{ carte_img.name }}
                                    <i class="el-icon-close carte-size" @click="delCarteImg(index,2)"></i>
                                </div>
                            </template>
                            <template v-else>
                                <div class="tip">{{ langPage['v4-signpage']['TXT_aucunfichierchoisi'] }}</div>
                            </template>
                        </div>
                    </el-form-item>
                    <div class="typename">{{ langPage['mobile-produits']['TXT_adresse'].toUpperCase() }}</div>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_nomdemarque']">
                        <template v-if="sellerForm2.marques && sellerForm2.marques.length<=1">
                            <el-input class="input" v-model="sellerForm2.marques[0]"></el-input>
                        </template>
                        <template v-else>
                            <el-input
                                class="input"
                                :class="{'mar-bot':index<sellerForm2.marques.length-1}"
                                v-model="sellerForm2.marques[index]"
                                v-for="(items,index) in sellerForm2.marques"
                                :key="index"
                            ></el-input>
                        </template>
                    </el-form-item>
                    <el-form-item>
                        <div style="width: 100%;" class="whiteBtn" @click="addMarques">
                            {{ langPage['v4-inscription-grossistes']['TXT_ajoutmarque'] }}
                        </div>
                    </el-form-item>
                </el-form>
                <el-form
                    v-if="type == 'seller'&&step == 3"
                    :rules="sellerRules"
                    label-position="top"
                    ref="buyerForm5"
                    :model="sellerForm3"
                >
                    <el-form-item :label="langPage['v4-topmenu']['TXT_uploadlogo']">
                        <!-- <el-upload
                                            class="upload-demo"
                                            action="https://jsonplaceholder.typicode.com/posts/"
                                            multiple
                                            :limit="3"
                                            :file-list="fileList"
                                            style="display: inline-block;margin-right: 12px;">
                                        <el-button size="middle">Choisir un fichier</el-button>
                        </el-upload>-->
                        <input
                            id="file_logo"
                            name="file_logo"
                            type="file"
                            accept="image/*"
                            value
                            ref="logo_upload"
                            hidden
                            @change="logoFile"
                        />
                        <label for="file_logo" class="file-btn">{{
                                langPage['v4-inscription-grossistes']['TXT_choisirunfichir']
                            }}</label>
                        <div class="tip-warp">
                            <template v-if="logo_img.name">
                                <div class="tip">
                                    {{ logo_img.name }}
                                    <i class="el-icon-close carte-size" @click="delLogoImg(index,2)"></i>
                                </div>
                            </template>
                            <template v-else>
                                <div class="tip">{{ langPage['v4-signpage']['TXT_aucunfichierchoisi'] }}</div>
                            </template>
                        </div>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_selectionezvotre']">
                        <el-select v-model="sellerForm3.type_categoire" multiple
                                   :placeholder="langPage['v4-topmenu']['TXT_selectionnerlesoptions']"
                                   @remove-tag="removeTag" @change="votChange">
                            <el-option
                                v-for="item in cities"
                                :key="item.id_categorie"
                                :label="item.libelle"
                                :value="item.id_categorie"
                            >
                                <div @click="stopEvent">
                                    <el-checkbox-group v-model="checkList">
                                        <el-checkbox :label="item.id_categorie">{{ item.libelle }}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <!-- <span style="float: left">{{ item.label }}</span> -->
                                <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span> -->
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_siteweb']">
                        <el-input class="input" placeholder="http://" v-model="sellerForm3.site_web"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['catalogue-quickview']['TXT_description']">
                        <el-input type="textarea" :rows="2" v-model="sellerForm3.description"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_montantminimum']">
                        <el-input class="input" v-model="sellerForm3.commandeMini"></el-input>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_gammedeprix']">
                        <el-slider v-model="sellerForm3.price_range" range :max="200"
                                   @change="silderChange"></el-slider>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_languepardefaut']">
                        <el-select v-model="sellerForm3.id_langue" placeholder>
                            <el-option
                                v-for="item in langDate"
                                :label="item.label"
                                :value="item.value"
                                :key="item.label"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="langPage['v4-topmenu']['TXT_domainedactivite']">
                        <collesp-singPage :list="typeDateList" @subCateogire="subCateogire"></collesp-singPage>
                        <!-- <el-checkbox-group v-model="checked">
                          <el-checkbox
                            v-for="(item,num) in businessScope"
                            :key="num"
                            :value="item.id_activite"
                            :label="item.id_activite"
                          >{{item.libelle}}</el-checkbox>
                        </el-checkbox-group>-->
                    </el-form-item>
                    <el-divider></el-divider>
                    <el-form-item>
                        <el-checkbox v-model="agreeMent">*{{
                                langPage['v4-signpage']['TXT_jaccecpteles']
                            }}
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="agreeMent"
                                     v-html="langPage['v4-signpage']['TAREA_vousnousautorisezaprelever']">
                        </el-checkbox>
                    </el-form-item>
                    <el-form-item>
                        <el-checkbox v-model="agreeMent" v-html="langPage['v4-signpage']['TAREA_vousnousautorisez']">
                        </el-checkbox>
                    </el-form-item>
                </el-form>
                <div class="stepControl">
                    <div class="nav">
                        <div class="backBtn" @click="stepChange('reduce')" v-if="step>1">&lt;
                            {{ langPage['edito-detail-fiche']['TXT_precedent'] }}
                        </div>
                    </div>
                    <div class="nav">
                        <button class="blackBtn" v-if="step == steptotal" @click="submit">
                            {{ langPage['v4-signpage']['TXT_terminer'] }}
                        </button>
                        <button class="blackBtn" @click="stepChange('add')" v-if="step < steptotal">
                            {{ langPage['edito-detail-fiche']['TXT_suivant'] }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {filterReg} from "../../utils/regexp";
import collespSingPage from "./-collesp-singPage";
import {VueTelInput} from 'vue-tel-input'
import {mapState} from "vuex";
import store from "@/store";

let commonUtils = require('../../utils/common_utils')

export default {
    name: "signPage",
    data() {
        const validateBuyerEmail = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t("account.word2")))
            }
            this.$api.auth.verify_email({email: value}).then(res => {
                console.log(res);
                if (res.code === 0) {
                    callback()
                } else {
                    callback(new Error(res.message))
                }
            })
        };
        const validateBuyerEmail2 = (rule, value, callback) => {
            if (this.buyerForm.email !== this.buyerForm.email2) {
                callback(new Error(this.$t("account.word3")))
            } else {
                callback()
            }
        };
        const validateSellerEmail = (rule, value, callback) => {
            if (!value) {
                callback(new Error(this.$t("account.word2")))
            }
            this.$api.auth
                .checkEmail({email: this.sellerForm1.email})
                .then(res => {
                    console.log(res)
                    if (res.code === 0 && res.data.registered) {
                        callback(new Error(this.$t("account.word3")))
                    } else if (res.code === 0 && !res.data.registered) {
                        callback()
                    }
                })
        };
        const validateSellerEmail2 = (rule, value, callback) => {
            if (this.sellerForm1.email !== this.sellerForm1.email2) {
                callback(new Error(this.$t("account.word3")))
            } else {
                callback()
            }
        };
        const validateBuyerSiret = (rule, value, callback) => {
            if (!value && !this.checkedHasNoBuyerSiret) {
                callback(new Error(this.langPage['v4-topmenu']['TXT_cechampestrequis']));
            }
            if (!this.buyerForm.adresses[0].id_pays) {
                callback(new Error(`country ${this.langPage['v4-topmenu']['TXT_cechampestrequis']}`));
            }
            let params = {vat_number: this.buyerForm.tva_intra, id_pay: this.buyerForm.adresses[0].id_pays};
            this.$api.auth.verify_siret(params).then(res => {
                if (res.code === 0) {
                    callback();
                    this.is_verify_buyer_tva_intra = true;
                } else {
                    //买家注册时税号错误不显示
                    // callback(new Error('siret failed validation'));
                    this.is_verify_buyer_tva_intra = false;
                }
            })
        };
        return {
            step: 1,
            id: "",
            cities: [],
            checkList: [],
            buyerForm: {
                prenomContact: "",
                nomContact: "",
                email: "",
                email2: "",
                password: "",
                password2: "",
                tva_intra: "",
                phone: "",
                mobile: "",
                activites: [],
                LangueDefaut: "",
                nomSociete: "",
                site_web: "",
                cgv: "",
                newsletter: "1",
                platform_notify_status: "1",
                sms_notify_status: "1",
                adresses: [
                    {
                        type: 1, //收货地址
                        id_annuaire: 0,
                        id_pays: "",
                        adresse: "",
                        ville: "",
                        telephone: "",
                        mobile: "",
                        fax: "",
                        NomContact: "",
                        codePostal: ""
                    },
                    {
                        type: 0, //发票地址
                        id_annuaire: 0,
                        id_pays: "",
                        adresse: "",
                        ville: "",
                        telephone: "",
                        mobile: "",
                        fax: "",
                        NomContact: "",
                        codePostal: ""
                    }
                ]
            },
            sellerForm1: {
                nomSociete: "",
                nomContact: "",
                prenomContact: "",
                mobile: "",
                telephone: "",
                email: "",
                password: "",
                password2: "",
                tva: "",
                nomBoutique: "",
                id_pays: ""
            },
            sellerForm2: {
                numero: "",
                rue: "",
                id_vendeur: "",
                carte_identite_boutique: "",
                kbis_boutique: "",
                ville: "",
                adresse: "",
                codePostal: "",
                iban: "",
                bic: "",
                marques: []
            },
            sellerForm3: {
                logo: "",
                type_categoire: [],
                site_web: "",
                description: "",
                commandeMini: "",
                prix_min: 0,
                prix_max: 200,
                type_sub_cateogire: [],
                id_langue: "fr",
                cguv: 0
            },
            kbis_img: {},//商家营业执照
            carte_img: {},//商家法人省份证
            logo_img: {},//商家logo
            kbis_img_buyer: {},//买家营业执照
            buyerRules: {},
            sellerRules: {},
            countryList: [],
            props: {multiple: true},
            businessScope: [],
            billAddress: true,
            checkedHasNoBuyerSiret: false,//勾选没有税号的按钮
            is_verify_buyer_tva_intra: false,//是否验证通过买家的税号
            checked: false,
            agreeMent: false,
            agreeMentSecret: false,
            id_langue: "fr",
            fileList: [],
            buyerKBISUrl: "",
            adresse_rue: "",
            adresse_ro: "",
            seAdresse_rue: "",
            seAdresse_ro: "",
            langDate: [
                {label: "FR", value: "fr"},
                {label: "EN", value: "en"},
                {label: "ES", value: "es"},
                {label: "IT", value: "it"}
            ],
            typeDateList: {},
            formRulesBuyer1: {
                email: [{required: true, trigger: 'blur', validator: validateBuyerEmail}],
                email2: [{required: true, trigger: 'blur', validator: validateBuyerEmail2}],
                tva_intra: [{required: true, trigger: 'change', validator: validateBuyerSiret}],
            },
            formRulesSeller: {
                email: [{required: true, trigger: 'blur', validator: validateSellerEmail}],
                email2: [{required: true, trigger: 'blur', validator: validateSellerEmail2}],
            },
            fileListKBIS: [],
            is_show_eori: false,
        };
    },

    created() {
        this.init()
    },
    methods: {
        init() {
            console.log('buyerSignForm', JSON.parse(JSON.stringify(this.$store.state.buyerSignForm)));
            if (!commonUtils.isEmpty(JSON.parse(JSON.stringify(this.$store.state.buyerSignForm)))) this.buyerForm = this.$store.state.buyerSignForm;
            // console.log(this.categories)
            let arrs = []
            let objs = {
                femmes: [],
                hommes: [],
                enfants: []
            }
            for (const i in this.categories) {
                if (this.categories[i] && i.length == 2) {
                    arrs.push(this.categories[i].categories_langues[0])
                }
                if (this.categories[i] && this.categories[i].subcategories) {
                    for (const k in this.categories[i].subcategories) {
                        if (i == 11) {
                            objs['femmes'].push(this.categories[i].subcategories[k].categories_langues[0])
                        } else if (i == 12) {
                            objs['hommes'].push(this.categories[i].subcategories[k].categories_langues[0])
                        } else if (i == 13) {
                            objs['enfants'].push(this.categories[i].subcategories[k].categories_langues[0])
                        } else {
                            if (/1401|1501|1603/.test(k)) {
                                objs['femmes'].push(this.categories[i].subcategories[k].categories_langues[0])
                            } else if (/1402|1502|1605/.test(k)) {
                                objs['hommes'].push(this.categories[i].subcategories[k].categories_langues[0])
                            } else if (/1305|1306|1403/.test(k)) {
                                objs['enfants'].push(this.categories[i].subcategories[k].categories_langues[0])
                            } else if (/1604/.test(k)) {
                                objs['femmes'].push(this.categories[i].subcategories[k].categories_langues[0])
                                objs['hommes'].push(this.categories[i].subcategories[k].categories_langues[0])
                            }
                        }
                    }
                }
            }
            this.typeDateList = objs
            // console.log(this.typeDateList)
            this.cities = arrs
        },
        checkBox() {
            this.sellerForm3.type_categoire = this.checkList
        },
        subCateogire(data) {
            this.sellerForm3.type_sub_cateogire = data
        },
        silderChange(val) {

            console.log(val)
        },
        stopEvent(e) {
            e.preventDefault()
        },
        votChange(val) {
            // console.log(val)
            this.checkList = val
        },
        removeTag(val) {
            this.checkList.forEach((item, index) => {
                if (val == item) {
                    this.checkList.splice(index, 1)
                }
            })
        },
        carteFile(e, type) {
            let file = e.target.files[0];
            if (file.size > 1024 * 1024 * 5) {
                this.$message.warning(this.$t("文件大小不能超过5M!"));
                return
            }
            switch (type) {
                case 1:
                    this.kbis_img = file;
                    break;
                case 2:
                    this.carte_img = file;
                    break;
                case 100://100以上的图片类型算买家的，100以内的算卖家的
                    this.kbis_img_buyer = file;
                    break;
            }
            console.log('选择的kbis_img_buyer：', this.kbis_img_buyer)
            // this[fileType] = this.filterArr(this[fileType], imgList);
        },
        // filterArr(cur, para) {
        //   let concatArr = [];
        //   if (cur && cur.length > 0) {
        //     for (var k = 0; k < cur.length; k++) {
        //       for (var j = 0; j < para.length; j++) {
        //         if (cur[k].name == para[j].name) {
        //           para.splice(para[j], 1);
        //         }
        //       }
        //       concatArr = cur.concat(para);
        //     }
        //     return concatArr;
        //   }
        //   return cur.concat(para);
        // },
        logoFile(e) {
            let file = e.target.files[0];
            if (file.size > 1024 * 1024 * 5) {
                this.$message.warning(this.$t("文件大小不能超过5M!"));
                return;
            }
            this.logo_img = file;
        },
        delLogoImg() {
            this.logo_img = {};
        },
        delCarteImg(val, key) {
            let objType = "";
            switch (key) {
                case 1:
                    objType = "kbis_img";
                    break;
                case 2:
                    objType = "carte_img";
                    break;
                case 100:
                    objType = "kbis_img_buyer";
                    break;
            }
            this[objType] = {}
        },
        addMarques() {
            let marList = this.sellerForm2.marques;
            marList.push("");
            this.sellerForm2.marques = marList;
        },
        sellRegistPost() {
            let param = new FormData(),
                data = {...this.sellerForm1, ...this.sellerForm2, ...this.sellerForm3};
            for (let key in data) {
                if (key === 'carte_identite_boutique') {
                    param.append(key, this.carte_img);
                } else if (key === 'kbis_boutique') {
                    param.append(key, this.kbis_img);
                } else if (key === 'logo' && this.logo_img.name) {
                    param.append(key, this.logo_img);
                } else {
                    if (data[key] !== '') {
                        param.append(key, data[key]);
                    }
                }
            }
            this.$loading({
                lock: true,
                spinner: "el-icon-loading"
            });
            this.$api.auth.sellerSign(param).then(data => {
                if (data.code === 0) {
                    // if (this.step === 1 && data.data.id_vendeur) {
                    //   this.sellerForm2.id_vendeur = data.data.id_vendeur;
                    // }
                    this.$router.push({name: "register-success"});
                    window.scrollTo(0, 0);
                } else {
                    this.$message.error(data.message);
                }
            })
                .finally(() => {
                    this.$loading().close();
                });
        },
        stepChange(change) {
            if (change == "add") {
                // console.log(this.type)
                if (this.type == "seller") {
                    if (this.step === 1) {
                        if (!this.sellerForm1.nomSociete) {
                            this.$message.warning(this.$t("sellRegister.sell1"));
                            return;
                        }
                        if (!this.sellerForm1.nomContact) {
                            this.$message.warning(this.$t("sellRegister.sell2"));
                            return;
                        }
                        if (!this.sellerForm1.prenomContact) {
                            this.$message.warning(this.$t("sellRegister.sell3"));
                            return;
                        }
                        if (!this.sellerForm1.mobile) {
                            this.$message.warning(this.$t("buyRegister.iphone"));
                            return;
                        }
                        if (!this.sellerForm1.email) {
                            this.$message.warning(this.$t("buyRegister.email"));
                            return;
                        }
                        if (!filterReg(this.sellerForm1.email, "email")) {
                            this.$message.warning(this.$t("buyRegister.emailType"));
                            return;
                        }
                        if (!this.sellerForm1.password) {
                            this.$message.warning(this.$t("buyRegister.pwd"));
                            return;
                        }
                        if (!filterReg(this.sellerForm1.password, "pwd")) {
                            this.$message.warning(this.$t("buyRegister.pwdType"));
                            return;
                        }
                        if (!this.sellerForm1.password2) {
                            this.$message.warning(this.$t("buyRegister.confpwd"));
                            return;
                        }
                        if (!filterReg(this.sellerForm1.password2, "pwd")) {
                            this.$message.warning(this.$t("buyRegister.pwdType"));
                            return;
                        }
                        if (this.sellerForm1.password !== this.sellerForm1.password2) {
                            this.$message.warning(this.$t("buyRegister.errorPwd"));
                            return;
                        }
                        if (!this.sellerForm1.tva) {
                            this.$message.warning(this.$t("sellRegister.sell4"));
                            return;
                        }
                        if (!this.sellerForm1.nomBoutique) {
                            this.$message.warning(this.$t("sellRegister.sell5"));
                            return;
                        }
                        if (!this.sellerForm1.id_pays) {
                            this.$message.warning(this.$t("buyRegister.country"));
                            return;
                        }
                        this.$loading({
                            lock: true,
                            spinner: "el-icon-loading"
                        });
                        this.$api.auth
                            .checkEmail({email: this.sellerForm1.email})
                            .then(res => {
                                if (res.code === 0 && !res.data.registered) {
                                    this.sellerForm2.marques = [""];
                                    this.step++;
                                    window.scrollTo(0, 0);
                                } else if (res.code === 0 && res.data.registered) {
                                    this.$message.warning(this.$t("sellRegister.sell6"));
                                }
                            })
                            .finally(() => {
                                this.$loading().close();
                            });
                    } else if (this.step === 2) {
                        if (!this.sellerForm2.numero) {
                            this.$message.warning(this.$t("sellRegister.sell7"));
                            return;
                        }
                        if (!this.sellerForm2.rue) {
                            this.$message.warning(this.$t("sellRegister.sell8"));
                            return;
                        }
                        if (!this.sellerForm2.ville) {
                            this.$message.warning(this.$t("sellRegister.sell9"));
                            return;
                        }
                        if (!this.sellerForm2.adresse) {
                            this.$message.warning(this.$t("sellRegister.sell10"));
                            return;
                        }
                        if (!this.sellerForm2.codePostal) {
                            this.$message.warning(this.$t("sellRegister.sell11"));
                            return;
                        }
                        if (!this.kbis_img.name) {
                            this.$message.warning(this.$t("sellRegister.sell12"));
                            return;
                        }
                        if (!this.sellerForm2.iban) {
                            this.$message.warning(this.$t("sellRegister.sell13"));
                            return;
                        }
                        if (!this.sellerForm2.bic) {
                            this.$message.warning(this.$t("sellRegister.sell14"));
                            return;
                        }
                        if (!this.carte_img.name) {
                            this.$message.warning(this.$t("sellRegister.sell15"));
                            return;
                        }
                        if (this.sellerForm2.marques[0] == "") {
                            this.$message.warning(this.$t("sellRegister.sell16"));
                            return;
                        }
                        this.step++;
                        window.scrollTo(0, 0);
                        this.sellerForm2.marques = this.sellerForm2.marques.filter(item => {
                            return item != "";
                        });
                    }
                } else if (this.type == "buyer") {
                    if (!this.buyerForm.prenomContact) {
                        this.$message.warning(this.$t("buyRegister.mainName"));
                        return;
                    }
                    if (!this.buyerForm.nomContact) {
                        this.$message.warning(this.$t("buyRegister.firstName"));
                        return;
                    }
                    if (!this.buyerForm.email) {
                        this.$message.warning(this.$t("buyRegister.email"));
                        return;
                    }
                    if (!filterReg(this.buyerForm.email, "email")) {
                        this.$message.warning(this.$t("buyRegister.emailType"));
                        return;
                    }
                    if (!this.buyerForm.email2) {
                        this.$message.warning(this.$t("buyRegister.confemail"));
                        return;
                    }
                    if (!filterReg(this.buyerForm.email2, "email")) {
                        this.$message.warning(this.$t("buyRegister.emailType"));
                        return;
                    }
                    if (this.buyerForm.email !== this.buyerForm.email2) {
                        this.$message.warning(this.$t("buyRegister.errorEmail"));
                        return;
                    }
                    // if (!this.buyerForm.mobile) {
                    //     this.$message.warning(this.$t("buyRegister.iphone"));
                    //     return;
                    // }
                    // if(!this.buyerForm.phone) {
                    //     this.$message.warning(this.$t('buyRegister.num'));
                    //     return
                    // }
                    if (!this.buyerForm.password) {
                        this.$message.warning(this.$t("buyRegister.pwd"));
                        return;
                    }
                    if (!filterReg(this.buyerForm.password, "pwd")) {
                        this.$message.warning(this.$t("buyRegister.pwdType"));
                        return;
                    }
                    if (!this.buyerForm.password2) {
                        this.$message.warning(this.$t("buyRegister.confpwd"));
                        return;
                    }
                    if (!filterReg(this.buyerForm.password2, "pwd")) {
                        this.$message.warning(this.$t("buyRegister.pwdType"));
                        return;
                    }
                    if (this.buyerForm.password !== this.buyerForm.password2) {
                        this.$message.warning(this.$t("buyRegister.errorPwd"));
                        return;
                    }
                    this.step++;
                }
                // console.log(this.step)
            }
            if (change == "reduce") {
                this.step--;
            }
            this.stepUpdate();
        },
        rueJoin() {
            this.buyerForm.adresses[0].adresse = this.adresse_ro + this.adresse_rue;
        },
        seRueJoin() {
            this.buyerForm.adresses[1].adresse =
                this.seAdresse_ro + this.seAdresse_rue;
        },
        agreeMentCvg(data) {
            if (data) this.buyerForm.cgv = 1;
            else this.buyerForm.cgv = 0;
        },
        stepUpdate() {
            let stepData = this.step / this.steptotal;
            this.$store.commit("set", {key: "stepData", value: stepData});
        },
        imgGet(e) {
            var self = this;
            let file = e.target.files[0];
            /* eslint-disable no-undef */
            let param = new FormData(); // 创建form对象
            param.append("file", file); // 通过append向form对象添加数据
            param.append("chunk", "0"); // 添加form表单中其他数据
            console.log(param.get("file")); // FormData私有类对象，访问不到，可以通过get判断值是否传进去
        },
        submit() {
            if (this.type == "buyer") {
                // console.log(this.buyerForm)
                if (this.billAddress) {
                    this.buyerForm.adresses[1] = {...this.buyerForm.adresses[0]};
                    this.seAdresse_ro = this.adresse_ro;
                    this.seAdresse_rue = this.adresse_rue;
                    this.buyerForm.adresses[1].type = 0;
                }
                let reqData = {...this.buyerForm};
                let param = new FormData();
                for (var keys in reqData) {
                    if (reqData[keys] || reqData[keys].length > 0) {
                        param.append(keys, reqData[keys]);
                    }
                }
                param.append('is_verify_buyer_tva_intra', this.is_verify_buyer_tva_intra);
                param.delete('adresses');
                param.append('adresses', JSON.stringify(this.buyerForm.adresses));
                param.append('kbis_img_buyer', this.kbis_img_buyer);
                if (!this.submitEmpty()) return;
                this.$loading({
                    lock: true,
                    spinner: "el-icon-loading"
                });
                this.$api.auth
                    .buyerSign(param)
                    .then(res => {
                        // console.log(data)
                        // localStorage.setItem('token',data.token)
                        // localStorage.setItem('lang',this.buyerForm.LangueDefaut)
                        // this.$i18n.locale = this.buyerForm.LangueDefaut
                        let data = res.data;
                        if (res.code === 0) {
                            localStorage.setItem("id_acheteur", data.id_acheteur);
                            this.buyerKBISUrl = "../" + data.id_acheteur + "/kbis";
                            this.$router.push({name: "register-success"});
                        } else {
                            this.$message.error(res.message);
                            //   this.$router.push({ name: "result", query: { type: 3 } });
                        }
                        // this.$refs.buyerkb.submit();
                    })
                    .finally(() => {
                        this.$loading().close();
                    });
            } else if (this.type == "seller") {
                if (this.step === 3) {
                    if (this.sellerForm3.type_categoire.length <= 0) {
                        this.$message.warning(this.$t("sellRegister.sell17"));
                        return;
                    }
                    console.log(this.sellerForm3.commandeMini)
                    if (!this.sellerForm3.commandeMini) {
                        this.$message.warning(this.$t("sellRegister.sell18"));
                        return;
                    }
                    if (isNaN(this.sellerForm3.commandeMini)) {
                        this.$message.warning(this.$t("sellRegister.sell19"));
                        return;
                    }
                    if (this.sellerForm3.type_sub_cateogire.length <= 0) {
                        this.$message.warning(this.$t("sellRegister.sell20"));
                        return;
                    }
                    if (!this.sellerForm3.cguv) {
                        this.$message.warning(this.$t("buyRegister.word16"));
                        return;
                    }
                    this.sellRegistPost()
                }
            }
            // this.step = 0
            // this.stepUpdate()
            // this.$router.push('/sign/signSuc')
        },
        submitEmpty() {
            if (!this.adresse_ro) {
                //街道号
                this.$message.warning(this.$t("buyRegister.word1"));
                return;
            }
            if (!this.adresse_rue) {
                //街道名称
                this.$message.warning(this.$t("buyRegister.word2"));
                return;
            }
            if (!this.buyerForm.adresses[0].ville) {
                //城市
                this.$message.warning(this.$t("buyRegister.word3"));
                return;
            }
            if (this.buyerForm.adresses[0].mobile.length < 6) {
                //手机号
                this.$message.warning(this.$t("buyRegister.word4"));
                return;
            }
            if (!this.buyerForm.adresses[0].NomContact) {
                //地址联系人姓
                this.$message.warning(this.$t("buyRegister.word5"));
                return;
            }
            if (!this.buyerForm.adresses[0].codePostal) {
                //邮编
                this.$message.warning(this.$t("buyRegister.word5"));
                return;
            }
            if (!this.seAdresse_ro) {
                //街道号
                this.$message.warning(this.$t("buyRegister.word7"));
                return;
            }
            if (!this.seAdresse_rue) {
                //街道名称
                this.$message.warning(this.$t("buyRegister.word8"));
                return;
            }
            if (!this.buyerForm.adresses[1].ville) {
                //城市
                this.$message.warning(this.$t("buyRegister.word9"));
                return;
            }
            if (this.buyerForm.adresses[1].mobile.length < 6) {
                //手机号
                this.$message.warning(this.$t("buyRegister.word10"));
                return;
            }
            if (!this.buyerForm.adresses[1].NomContact) {
                //地址联系人姓
                this.$message.warning(this.$t("buyRegister.word11"));
                return;
            }
            if (!this.buyerForm.adresses[1].codePostal) {
                //邮编
                this.$message.warning(this.$t("buyRegister.word12"));
                return;
            }
            if (!this.buyerForm.nomSociete) {
                //用户名
                this.$message.warning(this.$t("buyRegister.word13"));
                return;
            }
            if (!this.buyerForm.tva_intra && this.is_verify_buyer_tva_intra && !this.checkedHasNoBuyerSiret) {
                //企业税号
                this.$message.warning(this.$t("buyRegister.intra"));
                return;
            }
            if (!this.buyerForm.adresses[0].id_pays) {
                //国家ID
                this.$message.warning(this.$t("buyRegister.country"));
                return;
            }
            //   if (!this.buyerForm.site_web) {
            //     //网站
            //     this.$message.warning(this.$t("buyRegister.webSite"));
            //     return;
            //   }
            //   if (!filterReg(this.buyerForm.site_web, "url")) {
            //     this.$message.warning(this.$t("buyRegister.confwebSite"));
            //     return;
            //   }
            if (!this.buyerForm.LangueDefaut) {
                //默认语言
                this.$message.warning(this.$t("buyRegister.word14"));
                return;
            }
            if (this.buyerForm.activites.length <= 0) {
                //用户营业范围
                this.$message.warning(this.$t("buyRegister.word15"));
                return;
            }
            if (!this.buyerForm.cgv || (this.type === 'buyer' && !this.agreeMentSecret)) {
                //用户条款
                this.$message.warning(this.$t("buyRegister.word16"));
                return;
            }
            if (this.buyerForm.adresses[0].id_pays == 27 && !this.buyerForm.eori) {
                //英国买家，必须填写eori号码
                this.$message.warning(this.$t("buyRegister.word17"));
                return;
            }
            return true;
        },
        onChangePhoneCountry(country, key) {
            switch (key) {
                case 'buyerForm.adresses[0].mobile':
                    this.buyerForm.adresses[0].mobile = country.dialCode;
                    break;
                case 'buyerForm.adresses[0].telephone':
                    this.buyerForm.adresses[0].telephone = country.dialCode;
                    break;
                case 'buyerForm.adresses[1].mobile':
                    this.buyerForm.adresses[1].mobile = country.dialCode;
                    break;
                case 'buyerForm.adresses[1].telephone':
                    this.buyerForm.adresses[1].telephone = country.dialCode;
                    break;
            }
            this.$forceUpdate();
        },
        onChangeBuyerCountry(id_pays) {
            let country = this.countryList.find(item => item.id_pays === id_pays);
            if (country.is_cee === 1 && country.code !== 'FR' && country.id_pays !== 28) {
                this.buyerForm.tva_intra = country.code;
            } else this.buyerForm.tva_intra = '';
            //是英国要要求设置eori
            this.is_show_eori = country.id_pays == 24;
        },
        onCheckHasNoBuyerSiret() {
            let that = this;
            setTimeout(function () {
                if (that.checkedHasNoBuyerSiret) {
                    that.buyerForm.tva_intra = null;
                    that.$forceUpdate()
                }
            }, 100)
        }
    },
    computed: {
        type() {
            return this.$route.params.type;
        },
        categories() {
            return this.$store.state.categories
        },
        steptotal() {
            let type = this.type,
                total = 0;
            if (type == "buyer") {
                total = 2;
            } else if (type == "seller") {
                total = 3;
            } else {
                total = 1;
            }
            return total;
        },
        langPage() {
            return this.$store.state['langPage']
        }
    },

    watch: {
        billAddress(val) {
            if (val) {
                this.seAdresse_ro = "";
                this.seAdresse_rue = "";
            }
        },
        'sellerForm3.commandeMini'(val) {
            if (val.search('-') != -1 || val <= 0) {
                this.sellerForm3.commandeMini = ''
            } else {
                this.sellerForm3.commandeMini = val
            }
        },
        agreeMent(val) {
            if (val) this.sellerForm3.cguv = 1
            else this.sellerForm3.cguv = 0
        },
    },
    mounted() {
        this.stepUpdate();
        this.id_langue = store.state['lang'] ? store.state['lang'] : 'fr';
        this.$api.auth.countryGet().then(data => {
            let list = [];
            data.forEach(item => {
                let country = {};
                country.id_pays = item.id_pays;
                country.code = item.code;
                country.is_cee = item.is_cee;
                country.text = this.id_langue == 'en' ? item.texte_uk : item[`texte_${this.id_langue}`];
                list.push(country);
            });
            this.countryList = list;
        });
        this.$api.auth.businessScope({id_langue: this.id_langue}).then(data => {
            this.businessScope = data.result;
        });
    },
    updated() {
        this.$store.commit('set', {key: 'buyerSignForm', value: this.buyerForm});
    },
    components: {
        collespSingPage,
        VueTelInput,
    }
};
</script>

<style lang="less">

.signPage {
    .el-checkbox {
        p {
            flex-wrap: wrap;
            white-space: pre-wrap;
        }
    }
}


.msignPage {
    .el-checkbox {
        p {
            flex-wrap: wrap;
            white-space: pre-wrap;
        }
    }
}

</style>

<style lang="less" scoped src="@/assets/viewCss/views/Sign/SignPage.less">
</style>
